import { render, staticRenderFns } from "./institutionCardDialog.vue?vue&type=template&id=b74c00d6"
import script from "./institutionCardDialog.vue?vue&type=script&lang=ts"
export * from "./institutionCardDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports